/**
 * Convert percentage grade to 4.0 GPA scale
 * @param {number} percent - Percentage grade (0-100)
 * @returns {number} GPA on 4.0 scale
 */
export function convertToFourPointScale(percent) {
	const p = parseFloat(percent)
	if (isNaN(p)) return 0

	if (p >= 97) return 4.0
	if (p >= 93) return 4.0
	if (p >= 90) return 3.7
	if (p >= 87) return 3.3
	if (p >= 83) return 3.0
	if (p >= 80) return 2.7
	if (p >= 77) return 2.3
	if (p >= 73) return 2.0
	if (p >= 70) return 1.7
	if (p >= 67) return 1.3
	if (p >= 65) return 1.0
	return 0.0
}

/**
 * Get color for percentage grade
 */
export function getGradeColor(grade) {
	if (grade >= 90) return '#007bff'
	if (grade >= 80) return '#28a745'
	if (grade >= 70) return '#ffc107'
	if (grade >= 65) return '#fd7e14'
	return '#dc3545'
}

/**
 * Get color for GPA value
 */
export function getGPAColor(gpa) {
	if (gpa >= 3.89) return '#b3e5fc'
	if (gpa >= 3.69) return '#c8e6c9'
	if (gpa >= 3.29) return '#fff9c4'
	if (gpa >= 2.99) return '#ffe0b2'
	if (gpa >= 2.29) return '#ffcdd2'
	return '#ef9a9a'
}

/**
 * Get color for credit value
 */
export function getCreditColor(credit) {
	if (credit >= 10) return '#6f42c1'
	if (credit >= 7.5) return '#20c997'
	if (credit >= 5) return '#17a2b8'
	if (credit >= 2.5) return '#ffc107'
	return '#e83e8c'
}

/**
 * Get color for AP score
 */
export function getAPScoreColor(score) {
	if (score === 5) return '#007bff'
	if (score === 4) return '#28a745'
	if (score === 3) return '#ffc107'
	if (score === 2) return '#fd7e14'
	return '#dc3545'
}

/** Month columns in GPA-Grades 2 — must stay in sync with GradeInMonth2 */
export const GPA_GRADES_MONTH_ORDER = [
	'September',
	'October',
	'November',
	'December',
	'January',
	'February',
	'March',
	'April',
	'May',
	'June'
]

/** Quarter / semester columns after months — same order as GradeInMonth2 */
export const GPA_GRADES_PERIOD_ORDER = ['Quarter 1', 'Quarter 2', 'Quarter 3', 'Quarter 4', 'Semester 1', 'Semester 2']

/**
 * Timeline position for a period label (higher = later in the school year in GPA-Grades 2).
 * Used as tie-breaker when picking which grade to show if timestamps are missing.
 */
export function gradePeriodSortKey(label) {
	if (label == null || label === '') return 999
	const mi = GPA_GRADES_MONTH_ORDER.indexOf(label)
	if (mi !== -1) return mi
	const pi = GPA_GRADES_PERIOD_ORDER.indexOf(label)
	if (pi !== -1) return GPA_GRADES_MONTH_ORDER.length + pi
	return 999
}

/**
 * Milliseconds for "most recently saved" ordering of a gradeinmonths row.
 * Prefers updated_at over created_at. Supports snake_case (Supabase) and camelCase.
 * Returns 0 if no usable timestamp (caller may fall back to id / period order).
 */
export function gradeRecordRecencyMs(record) {
	if (!record) return 0
	const raw =
		record.updated_at ??
		record.updatedAt ??
		record.created_at ??
		record.createdAt
	if (raw == null || raw === '') return 0
	const ms = new Date(raw).getTime()
	return Number.isNaN(ms) ? 0 : ms
}
